import { InvoiceLineItemValidation } from 'src/redux/billing/billing.types';

function isArchivedValidation(v: InvoiceLineItemValidation): boolean {
  return (v.status ?? '').trim().toLowerCase() === 'archived';
}

/**
 * True when the API marks the row as missing or the field name references missing.
 */
export function isMissingLineItemValidation(v: InvoiceLineItemValidation): boolean {
  if (v.is_missing) {
    return true;
  }
  const f = (v.field ?? '').trim().toLowerCase();
  return f.includes('missing');
}

/** Missing validations for display (excludes archived). */
export function getMissingLineItemValidations(
  validations: InvoiceLineItemValidation[]
): InvoiceLineItemValidation[] {
  return validations.filter((v) => !isArchivedValidation(v) && isMissingLineItemValidation(v));
}

/** Distinct line item IDs that have at least one missing validation. */
export function countDistinctLineItemsWithMissingValidations(
  validations: InvoiceLineItemValidation[]
): number {
  const missing = getMissingLineItemValidations(validations);
  return new Set(missing.map((v) => v.line_item)).size;
}
